import _ from 'lodash';

var base = {
  get locale() {
    return 'en';
  },
  asset_url: 'http://' + window.location.hostname + ':3000',

  // List taken from supported, ActiveSupport::TimeZone
  time_zones: [
    'Africa/Algiers',
    'Africa/Cairo',
    'Africa/Casablanca',
    'Africa/Harare',
    'Africa/Johannesburg',
    'Africa/Monrovia',
    'Africa/Nairobi',
    'America/Argentina/Buenos_Aires',
    'America/Bogota',
    'America/Caracas',
    'America/Chicago',
    'America/Chihuahua',
    'America/Denver',
    'America/Godthab',
    'America/Guatemala',
    'America/Guyana',
    'America/Halifax',
    'America/Indiana/Indianapolis',
    'America/Juneau',
    'America/La_Paz',
    'America/Lima',
    'America/Los_Angeles',
    'America/Mazatlan',
    'America/Mexico_City',
    'America/Monterrey',
    'America/Montevideo',
    'America/New_York',
    'America/Phoenix',
    'America/Puerto_Rico',
    'America/Regina',
    'America/Santiago',
    'America/Sao_Paulo',
    'America/St_Johns',
    'America/Tijuana',
    'Asia/Almaty',
    'Asia/Baghdad',
    'Asia/Baku',
    'Asia/Bangkok',
    'Asia/Chongqing',
    'Asia/Colombo',
    'Asia/Dhaka',
    'Asia/Hong_Kong',
    'Asia/Irkutsk',
    'Asia/Jakarta',
    'Asia/Jerusalem',
    'Asia/Kabul',
    'Asia/Kamchatka',
    'Asia/Karachi',
    'Asia/Kathmandu',
    'Asia/Kolkata',
    'Asia/Krasnoyarsk',
    'Asia/Kuala_Lumpur',
    'Asia/Kuwait',
    'Asia/Magadan',
    'Asia/Muscat',
    'Asia/Novosibirsk',
    'Asia/Rangoon',
    'Asia/Riyadh',
    'Asia/Seoul',
    'Asia/Shanghai',
    'Asia/Singapore',
    'Asia/Srednekolymsk',
    'Asia/Taipei',
    'Asia/Tashkent',
    'Asia/Tbilisi',
    'Asia/Tehran',
    'Asia/Tokyo',
    'Asia/Ulaanbaatar',
    'Asia/Urumqi',
    'Asia/Vladivostok',
    'Asia/Yakutsk',
    'Asia/Yekaterinburg',
    'Asia/Yerevan',
    'Atlantic/Azores',
    'Atlantic/Cape_Verde',
    'Atlantic/South_Georgia',
    'Australia/Adelaide',
    'Australia/Brisbane',
    'Australia/Darwin',
    'Australia/Hobart',
    'Australia/Melbourne',
    'Australia/Perth',
    'Australia/Sydney',
    'Etc/GMT+12',
    'Etc/UTC',
    'Europe/Amsterdam',
    'Europe/Athens',
    'Europe/Belgrade',
    'Europe/Berlin',
    'Europe/Bratislava',
    'Europe/Brussels',
    'Europe/Bucharest',
    'Europe/Budapest',
    'Europe/Copenhagen',
    'Europe/Dublin',
    'Europe/Helsinki',
    'Europe/Istanbul',
    'Europe/Kaliningrad',
    'Europe/Kiev',
    'Europe/Lisbon',
    'Europe/Ljubljana',
    'Europe/London',
    'Europe/Madrid',
    'Europe/Minsk',
    'Europe/Moscow',
    'Europe/Paris',
    'Europe/Prague',
    'Europe/Riga',
    'Europe/Rome',
    'Europe/Samara',
    'Europe/Sarajevo',
    'Europe/Skopje',
    'Europe/Sofia',
    'Europe/Stockholm',
    'Europe/Tallinn',
    'Europe/Vienna',
    'Europe/Vilnius',
    'Europe/Volgograd',
    'Europe/Warsaw',
    'Europe/Zagreb',
    'Europe/Zurich',
    'Pacific/Apia',
    'Pacific/Auckland',
    'Pacific/Chatham',
    'Pacific/Fakaofo',
    'Pacific/Fiji',
    'Pacific/Guadalcanal',
    'Pacific/Guam',
    'Pacific/Honolulu',
    'Pacific/Majuro',
    'Pacific/Midway',
    'Pacific/Noumea',
    'Pacific/Pago_Pago',
    'Pacific/Port_Moresby',
    'Pacific/Tongatapu'
  ],
  scopes: [
    'read_orders',
    'write_orders',
    'read_shipments',
    'write_shipments',
    'read_rates',
    'write_rates',
    'read_order_channels',
    'write_order_channels',
    'read_carriers',
    'write_carriers',
    'write_carrier_approval',
    'read_users',
    'write_users',
    'read_brands',
    'write_brands',
    'read_printers',
    'write_printers',
    'read_mail_templates',
    'write_mail_templates',
    'read_slip_templates',
    'write_slip_templates',
    'read_advanced_mail_templates',
    'write_advanced_mail_templates',
    'read_barcode_ranges',
    'write_barcode_ranges',
    'read_order_channel_acls',
    'write_order_channel_acls',
    'read_carrier_acls',
    'write_carrier_acls',
    'read_store_acls',
    'write_store_acls',
    'read_access_tokens',
    'write_access_tokens',
    'write_all_access_tokens',
    'read_reports',
    'write_reports',
    'read_waybills',
    'write_waybills',
    'read_pickups',
    'write_pickups',
    'read_shipping_addresses',
    'write_shipping_addresses',
    'read_billing',
    'write_billing',
    'read_webhooks',
    'write_webhooks',
    'read_automations',
    'write_automations',
    'read_csv_mappings',
    'write_csv_mappings',
    'read_stores',
    'write_stores',
    'read_disabled_customers',
    'read_request_logs',
    'write_request_logs',
    'read_edis',
    'write_edis',
    'read_versions',
    'write_versions',
    'read_returns',
    'write_returns',
    'write_single_return', // Write single return scope if used for public returns page
    'read_return_portals',
    'write_return_portals',
    'read_document_library',
    'write_document_library',
    'read_favourite_pages',
    'write_favourite_pages',
    'read_hot_keys',
    'write_hot_keys',
    'read_cost_sheets',
    'write_cost_sheets',
    'read_dashboards',
    'write_dashboards',
    'write_accept_staff_access',
    'read_user_groups',
    'read_order_channel_types',
    'read_carrier_types',
    'read_activity_types',
    'write_activity_types',
    'read_activities',
    'write_activities',
    'read_document_templates',
    'write_document_templates',

    'admin',
    'write_carrier_types',
    'write_order_channel_types',
    'read_staffs',
    'write_staffs',
    'read_customers',
    'write_customers',
    'read_subscriptions',
    'write_subscriptions',
    'read_customer_tokens',
    'write_customer_tokens',
    'read_customer_notes',
    'write_customer_notes',
    'write_user_groups',
    'read_global_barcode_ranges',
    'write_global_barcode_ranges',
    'read_plans',
    'write_plans',
    'read_payment_terms',
    'write_payment_terms',
    'read_organizations',
    'write_organizations',
    'write_credit_memos',
    'read_error_messages',
    'write_error_messages',
    'read_change_logs',
    'write_change_logs',
    'read_staff_accesses',
    'write_staff_accesses',
    'write_override_staff_access',
    'read_purchases',
    'write_purchases',
    'read_white_label_reports',
    'write_white_label_reports',
    'read_developer_actions',
    'write_developer_actions'
  ]
};

const development = {
  environment: 'development',
  get client_api_endpoint() {
    return 'http://api.local.webshipr.com:3000/v2';
  },
  get api_endpoint() {
    return 'http://127.0.0.1:3000/v2/backend';
  },
  get frontend() {
    return { protocol: 'http://', domain: '.local.webshipr.com:9002' };
  }
};

const staging = {
  environment: 'staging',
  get api_endpoint() {
    return 'https://api.staging.webshipper.io/v2/backend';
  },
  get client_api_endpoint() {
    return 'https://api.staging.webshipper.io/v2';
  },
  get frontend() {
    return { protocol: 'https://', domain: '.staging.webshipper.io' };
  }
};

const production = {
  environment: 'production',
  get api_endpoint() {
    return 'https://api.webshipper.io/v2/backend';
  },
  get client_api_endpoint() {
    return 'https://api.webshipper.io/v2';
  },
  get frontend() {
    return { protocol: 'https://', domain: '.webshipper.io' };
  }
};

let env = null;

if (process.env.TARGET_ENV === 'staging') {
  env = staging;
} else if (process.env.TARGET_ENV === 'production') {
  env = production;
} else {
  env = development;
}

export default _.merge(base, env);
